import { Loader2 } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

export interface ImportProgressState {
  phase: 'categories' | 'products' | 'rawMaterials' | 'modifiers' | 'inventory';
  current: number;
  total: number;
  message: string;
}

interface ImportProgressProps {
  progress: ImportProgressState;
  onCancel?: () => void;
}

export function ImportProgress({ progress }: ImportProgressProps) {
  const percentage = progress.total > 0
    ? Math.round((progress.current / progress.total) * 100)
    : 0;

  const phaseLabels: Record<ImportProgressState['phase'], string> = {
    categories: 'Creating categories',
    products: 'Importing products',
    rawMaterials: 'Importing raw materials',
    modifiers: 'Creating modifiers',
    inventory: 'Setting up inventory',
  };

  return (
    <div className="space-y-6 py-8">
      <div className="flex flex-col items-center justify-center space-y-4">
        <div className="relative">
          <Loader2 className="h-12 w-12 animate-spin text-primary" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-xs font-bold">{percentage}%</span>
          </div>
        </div>

        <div className="text-center space-y-1">
          <p className="text-lg font-medium">{phaseLabels[progress.phase]}</p>
          <p className="text-sm text-muted-foreground">{progress.message}</p>
        </div>
      </div>

      <div className="space-y-2">
        <Progress value={percentage} className="h-2" />
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>{progress.current} of {progress.total}</span>
          <span>{percentage}% complete</span>
        </div>
      </div>

      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          Please do not close this window while the import is in progress
        </p>
      </div>
    </div>
  );
}
